import * as types from './../types'
import { post, fetch } from '../../utils/http'
import apiSetting from './../bbnews-api'

const state = {
  accessToken: null,
  refreshToken: null,
  userInfo: null
}

const mutations = {
  [types.USER_REGISTER]: (state, data) => {
    // state.username = data.username
    // state.email = data.email
  },

  [types.USER_LOGIN]: (state, data) => {
    localStorage.setItem(types.STORAGE_ACCESS_TOKEN, data.access)
    localStorage.setItem(types.STORAGE_REFRESH_TOKEN, data.refresh)
    state.accessToken = data.access
    state.refreshToken = data.refresh
  },

  [types.USER_LOGOUT]: state => {
    localStorage.clear()
    state.accessToken = null
    state.refreshToken = null
    state.userInfo = null
  },

  [types.USER_VERIFY]: state => {
    state.accessToken = null
  },

  [types.USER_REFRESH]: (state, data) => {
    localStorage.accessToken = data.access
    state.accessToken = data.access
  },

  [types.USER_INIT_INFO]: (state, data) => {
    state.userInfo = data
  }
}

const actions = {
  [types.USER_REGISTER]: (content, { username, email, password }) => {
    return post(apiSetting.register.url, {
      username: username,
      email: email,
      password: password
    }).then(response => {
      content.commit(types.USER_REGISTER, response)
    })
  },

  [types.USER_LOGIN]: (content, { email, password }) => {
    return post(apiSetting.login.url, {
      email: email,
      password: password
    }).then(response => {
      content.commit(types.USER_LOGIN, response)
      content.dispatch(types.SETTINGS_INIT_DATA)
    })
  },

  [types.USER_LOGOUT]: content => {
    content.commit(types.USER_LOGOUT)
    content.commit(types.SETTINGS_RESET)
    content.dispatch(types.SETTINGS_INIT_DATA)
  },

  [types.USER_REFRESH]: content => {
    return post(apiSetting.refreshToken.url, {
      refresh: content.state.refreshToken
    })
      .then(response => {
        content.commit(types.USER_REFRESH, response)
        content.dispatch(types.SETTINGS_INIT_DATA)
      })
      .catch(() => {
        content.dispatch(types.USER_LOGOUT)
      })
  },

  [types.USER_INIT_INFO]: content => {
    if (content.state.accessToken) {
      return fetch(apiSetting.userInfo.url).then(response => {
        content.commit(types.USER_INIT_INFO, response)
      })
    }
  }
}

export default {
  // namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js